// Scroll: sticky header, Lenis smooth scrolling, appear animations and anchor scrolling
// Returns the Lenis instance so other modules (preconfigurator popups) can stop/start it.
export default function () {

    const $ = jQuery;

    var scrollTrigger = 15;

    scrollTrigger += $('.header__main').outerHeight();

    $(document).on('scroll', function () {

        if ($(window).scrollTop() >= scrollTrigger) {

            $('.header__main').addClass('is-scrolled');

        } else if ($(window).scrollTop() < (scrollTrigger - 25)) { // Makes sure the bar does not bug at specific PX scrolls.

            $('.header__main').removeClass('is-scrolled');

        }

    });

    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Optional ease curve
        smooth: true,
        direction: 'vertical',
        gestureDirection: 'vertical',
        smoothTouch: false
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    // APPEAR TITLE animation
    $('[data-animation="appear-title"]').each(function () {
        const $el = $(this);
        const words = $el.html().split(/(\s+)/); // keep spaces
        $el.empty();

        // Wrap words in .line spans
        words.forEach(function (word) {
            if (word.trim() === '') {
                $el.append(document.createTextNode(word));
            } else {
                const line = $('<div class="line" style="display:inline-block;"></div>').html(word);
                $el.append(line);
            }
        });

        const lines = $el.find('.line');

        // Animate lines
        gsap.fromTo(lines, {
            y: '20px',
            opacity: 0
        }, {
            y: '0px',
            opacity: 1,
            duration: 0.5,
            stagger: 0.1,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: $el[0],
                start: 'top 90%',
                toggleActions: 'play none none none'
            }
        });
    });

    // Smooth scroll to anchor targets for buttons
    $('.u-button').click(function (e) {
        var href = $(this).attr('href');

        if (!href) return; // no href — do nothing

        try {
            var url = new URL(href, window.location.href);
            var hash = url.hash;

            if (hash && hash.length > 1) {
                var target = $(hash);
                if (target.length) {
                    e.preventDefault(); // stop default action

                    var targetOffset = target.offset().top;
                    var targetHeight = target.outerHeight();
                    var windowHeight = $(window).height();

                    // Scroll position to center the element
                    var scrollTo = targetOffset - (windowHeight / 2) + (targetHeight / 2);

                    $('html, body').animate({scrollTop: scrollTo + 'px'}, 800);
                }
            }
        } catch (err) {
            // let default behavior happen on error
        }
    });

    return lenis;
}
